module.exports = __webpack_public_path__ + "img/mail.39f9265d.svg";